import React, { useState, useRef, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Users from './components/content/Users';
import Cards from "./components/content/Cards";
import Alerts from './components/content/Alerts';
import Settings from './components/content/Settings';
import UserForm from './components/content/UserForm';
import Forms from "./components/content/Forms";
import UserDashboard from './components/content/UserDashboard';

const MainWrapper = ({ userType = 'user' }) => {
  const mainContentRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    // Focus main content on route changes
    if (mainContentRef.current) {
      // Ensure scroll position resets to top when navigating between tabs/routes
      try {
        mainContentRef.current.scrollTo({ top: 0, behavior: 'auto' });
      } catch (_) {
        // Fallback for older browsers
        mainContentRef.current.scrollTop = 0;
      }
      mainContentRef.current.focus();
    }
    // Announce route change
    const region = document.getElementById('route-change-region');
    if (region) {
      region.textContent = `Navigation: ${location.pathname.replace(/\//g, ' ').trim() || 'Home'}`;
    }
  }, [location.pathname]);

  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden">
      {/* Sidebar */}
      <Sidebar userType={userType} />

      {/* Main content */}
      <div className="flex flex-1 flex-col w-full md:pl-72">
        {/* Header */}
        <div className="sticky top-0 z-10">
          <Header />
        </div>

        {/* Page content */}
        <main id="main-content" ref={mainContentRef} role="main" tabIndex="-1" className="flex-1 w-full main-content-scroll pb-20 md:pb-0 outline-none">
          <Routes>
            {userType === 'admin' && (
              <>
                <Route path="users" element={<Users />} />
                <Route path="forms" element={<Forms />} />
                <Route path="alerts" element={<Alerts />} />
                <Route path="cards" element={<Cards />} />
              </>
            )}
            {userType === 'user' && (
              <>
                <Route path="dashboard" element={<UserDashboard />} />
                <Route path="form" element={<UserForm />} />
                <Route path="settings" element={<Settings />} />
              </>
            )}
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default MainWrapper;